/**
 * Property Profile API Service
 *
 * Raw fetch client for the ATTOM property profile endpoints on platform-admin-api.
 * Uses raw fetch (not openapi-fetch typed client) because the
 * platform-admin.openapi.yaml types have not yet been regenerated for these
 * new endpoints. Migrate to openapi-fetch once type generation is run.
 *
 * Endpoints:
 *   GET /api/v1/property/profiles/:attomId
 *   GET /api/v1/property/profiles/search?zipCode=&limit=
 */

import type { components } from '@aaimplatform/institutional-types/generated/platform-admin';

export type PropertyProfileResponse = components['schemas']['PropertyProfileResponse'];

// N6 cookie cutover (SEC-V04): the HttpOnly session cookie (credentials:
// 'include') authenticates these requests; the SPA attaches no bearer.

export const propertyProfileApi = {
  async getByAttomId(attomId: string): Promise<PropertyProfileResponse | null> {
    const res = await fetch(`/api/v1/property/profiles/${encodeURIComponent(attomId)}`, {
      headers: { Accept: 'application/json' },
      credentials: 'include',
    });
    if (res.status === 404) return null;
    if (!res.ok) throw new Error(`Failed to fetch profile: ${res.status}`);
    return res.json() as Promise<PropertyProfileResponse>;
  },

  async search(
    zipCode: string,
    limit = 20,
  ): Promise<{ profiles: PropertyProfileResponse[]; count: number }> {
    const params = new URLSearchParams({ zipCode, limit: String(limit) });
    const res = await fetch(`/api/v1/property/profiles/search?${params}`, {
      headers: { Accept: 'application/json' },
      credentials: 'include',
    });
    if (!res.ok) throw new Error(`Failed to search profiles: ${res.status}`);
    return res.json() as Promise<{ profiles: PropertyProfileResponse[]; count: number }>;
  },
};
